import { addOnDataMap } from '@/apps/billing-shared/src/definitions';

// Gamification tasks that can trigger onboarding journey
export const GAMIFICATION_TASK_BUSINESS_NAME = 'BusinessName';
export const GAMIFICATION_TASK_BUSINESS_INFO = 'BusinessInfo';
export const GAMIFICATION_TASK_INVITE_EMPLOYEE = 'InviteEmployee';
export const GAMIFICATION_TASK_PUBLISH_ROSTER = 'PublishRoster';
export const GAMIFICATION_TASK_APPROVE_TIMESHEET = 'ApproveTimesheet';
export const GAMIFICATION_TASK_MOBILE = 'Mobile';
export const GAMIFICATION_TASK_DOWNLOAD_APP = 'DownloadApp';
export const GAMIFICATION_TASK_BOOK_DEMO = 'BookDemo';

export const GAMIFICATION_TASK_NAMES_LEGACY_TO_RPC = {
  BusinessName: 'BUSINESS_NAME',
  BusinessInfo: 'SCHEDULING_RULES',
  InviteEmployee: 'INVITE_EMPLOYEE',
  PublishRoster: 'PUBLISH_ROSTER',
  ApproveTimesheet: 'APPROVE_TIMESHEET',
  Mobile: 'MOBILE_NUMBER',
  DownloadApp: 'EXPLORE_ECOSYSTEM',
  BookDemo: 'BOOK_DEMO',
  PaidAccount: 'PAID',
};

export const GAMIFICATION_TASK_NAMES_RPC_TO_LEGACY = {
  BUSINESS_NAME: 'BusinessName',
  SCHEDULING_RULES: 'BusinessInfo',
  INVITE_EMPLOYEE: 'InviteEmployee',
  PUBLISH_ROSTER: 'PublishRoster',
  APPROVE_TIMESHEET: 'ApproveTimesheet',
  MOBILE_NUMBER: 'Mobile',
  EXPLORE_ECOSYSTEM: 'DownloadApp',
  BOOK_DEMO: 'BookDemo',
  PAID: 'PaidAccount',
};

/** All onboarding step component names */
export const ONBOARDING_STEP_COMPONENTS = {
  NAME_BUSINESS: 'name-business',
  ADD_AREAS: 'add-areas',
  ADD_SCHEDULE: 'add-schedule',
  ADD_TEAM: 'add-team',
  INFO_TIMESHEET: 'info-timesheet',
  GEOFENCE_SETTINGS: 'geofence-settings',
  APPROVE_TIMESHEET: 'approve-timesheet',
  BOOK_DEMO: 'book-demo',
  PUBLISH_ROSTER: 'PublishRoster',
  DOWNLOAD_APP: 'download-app',
};

/** All setup wizard step names */
export const SETUP_WIZARD_STEPS = {
  LOCATIONS_AND_AREAS: 'locations-and-areas',
  ADD_TEAM: 'add-team',
  SUCCESS: 'success',
};

/** Max number of areas to pre-select when the Setup Areas step is opened */
export const MAX_PRESELECTED_AREAS = 5;

/** A set of default demo area names to use if the trial industry is unknown */
export const DEFAULT_DEMO_AREAS = [
  'Sales',
  'Admin',
  'Security',
  'Manager',
  'Staff',
];

/** A set of default payroll integrations to use if the API isnt available */
export const DEFAULT_PAYROLL_INTEGRATIONS = {
  AU: [
    { key: 'XR', name: 'Xero Payroll', logo: 'xero.svg' },
    { key: 'MO', name: 'MYOB AccountRight', logo: 'myob-accountright.svg' },
    { key: 'NS', name: 'NetSuite', logo: 'netsuite.svg' },
  ],
  US: [
    { key: 'ADP', name: 'ADP RUN', logo: 'adp-run.svg' },
    { key: 'ZP', name: 'Gusto', logo: 'gusto.svg' },
    { key: 'QB', name: 'Quickbooks', logo: 'quickbooks.svg' },
  ],
  GB: [{ key: 'XR', name: 'Xero Payroll', logo: 'xero.svg' }],
};

/** Default industry display name to use if the trial industry is unknown */
export const DEFAULT_INDUSTRY_DISPLAY_NAME = 'your';

/** Default Location ID to interact with during the Setup Business game */
export const DEFAULT_LOCATION_ID = 1;

/** Maximum allowed value for default mealbreak duration (in minutes) */
export const MAX_DEFAULT_MEALBREAK_DURATION = 240;

/** Shift Start time - first dropdown option (ISO format) */
export const SHIFT_START_TIME_OPTIONS_FIRST = '00:00';
/** Shift Start time - last dropdown option (ISO format) */
export const SHIFT_START_TIME_OPTIONS_LAST = '23:00';
/** Shift End time - last dropdown option (ISO format) */
export const SHIFT_END_TIME_OPTIONS_LAST = '23:30';
/** Increment between consecutive shift start or end time options (ISO format) */
export const SHIFT_START_END_TIME_OPTIONS_INCREMENT = 'PT30M';

export const PRESELECTED_LOCATION_SETTINGS_WEEK_START = 1;
export const PRESELECTED_LOCATION_SETTINGS_SHIFT_START_TIME = '09:00';
export const PRESELECTED_LOCATION_SETTINGS_SHIFT_END_TIME = '17:00';
export const PRESELECTED_LOCATION_SETTINGS_DEFAULT_MEALBREAK_DURATION = 30;

/** If set in session storage, the queued gamification task will be marked as complete on first load of gamification list */
export const STORAGE_KEY_QUEUED_GAMIFICATION_TASK_COMPLETION =
  'QueuedGamificationTaskCompletion';

export const PEOPLE_HELP_BANNER_HIDE_KEY = 'HideOnboardingPeople';
export const NEW_HIRE_ONBOARDING_HIDE_KEY = 'HideNewHireOnboarding';
export const DEPUTY_HR_BANNER_HIDE_KEY = 'HideDeputyHrBanner';
export const PEOPLE_HELP_BANNER_LEARN_MORE_URL =
  'https://help.deputy.com/hc/en-au/articles/4657767244303-Adding-Team-Members';

export const STORAGE_KEY_LOCATIONS_AND_AREAS_FIRST_SESSION_COMPLETION =
  'LocationsAndAreasFirstSessionCompletion';

export const SUPPORTED_PAYROLLS = [
  {
    key: 'XR',
    name: 'Xero',
    image: 'xero.png',
    trigger: 'modal',
  },
  {
    key: 'ADP',
    name: 'ADP Run',
    image: 'ADPRun.png',
    trigger: 'modal',
  },
  {
    key: 'ZP',
    name: 'Gusto',
    image: 'gusto.png',
    trigger: 'modal',
  },
  {
    key: 'MO',
    name: 'MYOB',
    image: 'MYOB.png',
    trigger: 'modal',
  },
  {
    key: 'QB',
    name: 'Quickbooks',
    image: 'quickbooks.png',
    trigger: 'modal',
  },
  {
    name: 'ADP Workforce Now',
    trigger: 'newTab',
    image: 'ADPWorkforceNow.png',
  },
  {
    name: 'BambooHR',
    trigger: 'newTab',
    image: 'bambooHR.png',
  },
  {
    name: 'Netsuite',
    image: 'netsuite.png',
    trigger: 'marketplace',
  },
  {
    name: 'FlareHR',
    trigger: 'marketplace',
    image: 'flare.png',
  },
  {
    name: 'HappyHR',
    trigger: 'marketplace',
    image: 'happyHR.png',
  },
  {
    name: 'Square',
    trigger: 'marketplace',
    image: 'square.png',
  },
  {
    name: 'Lightspeed',
    trigger: 'marketplace',
    image: 'lightspeed.png',
  },
  {
    name: 'Redcat',
    trigger: 'marketplace',
    image: 'redcat.png',
  },
  {
    name: 'Revel',
    trigger: 'marketplace',
    image: 'revel.png',
  },
  {
    name: 'Talech',
    trigger: 'marketplace',
    image: 'talech.png',
  },
  {
    name: 'Vend',
    trigger: 'marketplace',
    image: 'vend.png',
  },
];

export const PAYROLL_PROVIDER_RULES = {
  bamboohr: {
    include: 'bamboohr',
  },
  flarehr: {
    include: 'flare',
  },
  xero: {
    include: 'xero',
  },
  myob: {
    include: 'myob',
    exclude: 'exo',
  },
  quickbooks: {
    include: 'quickbooks',
    exclude: 'desktop',
  },
};

export const PAYROLL_APP_MAPPING_RULES = {
  lightspeed: 'lightspeed kounta',
  netsuite: 'netsuiteapp',
};

export const ADD_ONS = Object.keys(addOnDataMap).map(addOnId => {
  const addOn = addOnDataMap[addOnId];
  return {
    addOnId,
    title: addOn.name,
    imageSource: addOn.imageSource,
    description: addOn.translations.description,
    features: addOn.translations.features,
    featureFlag: addOn.featureFlag,
  };
});
